import Typography from "@mui/material/Typography";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { DateFormatter } from "../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { GeneratedCertificateRegistry } from "../../../Component/Model/Dto/GeneratedCertificateRegistry";

interface GeneratedCertificateRegistryTableRow {
    CertificateNumber: string;
    ScorecardName: string;
    RegisteredEntityName: string;
    StartDate: string;
    EndDate: string;
    IssueDate: string;
    ExpiryDate: string;
    ApplicableScorecardName: string;
    ScorecardType: string;
    ComplianceLevel: string;
    Actions?: ActionType[];
    CompanyName: ILinkProps;
}

interface ILinkProps {
    itemId?: number;
    itemName: string;
}

export interface IGeneratedCertificateRegistryTable {
    columns: Array<TableColumn>;
    rows: Array<GeneratedCertificateRegistryTableRow>;
}

export function GeneratedCertificateRegistryTableMapper(results: GeneratedCertificateRegistry.SearchResult[], onViewCertificate: (id: string) => void, setCompany: (id: number, name: string) => void): IGeneratedCertificateRegistryTable {
    const columns = [
        { Header: 'Certificate Number', accessor: 'CertificateNumber', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" /> },
        { Header: 'Scorecard Name', accessor: 'ScorecardName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" /> },
        { Header: 'Company Name', accessor: 'CompanyName', Cell: ({ value }: any) => <Typography variant="caption" fontWeight='regular' color="#007bff" style={{ cursor: "pointer" }} onClick={() => setCompany(value.itemId, value.itemName)}>{value.itemName}</Typography> },
        { Header: 'Applicable Scorecard', accessor: 'ApplicableScorecardName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Applicable B-BBEE Codes', accessor: 'ScorecardType', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" />, disableSortBy: true },
        { Header: 'Measurement Start Date', accessor: 'StartDate', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="45px" /> },
        { Header: 'Measurement End Date', accessor: 'EndDate', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="45px" /> },
        { Header: 'Issue Date', accessor: 'IssueDate', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="45px" /> },
        { Header: 'Expiry Date', accessor: 'ExpiryDate', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="45px" /> },
        { Header: 'Recognised Level', accessor: 'ComplianceLevel', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];


    if (results.length >= 0) {
        const rows: GeneratedCertificateRegistryTableRow[] = results.map((item: GeneratedCertificateRegistry.SearchResult, index: number) => (
            {
                CertificateNumber: item.certificateNumber,
                ScorecardName: item.scorecardName,
                RegisteredEntityName: item.registeredEntityName,
                CompanyName: { itemId: item.vaClientId, itemName: item.companyName },
                ApplicableScorecardName: item.applicableScorecardName,
                ScorecardType: item.scorecardType,
                StartDate: DateFormatter(item.startDate.toString()),
                EndDate: DateFormatter(item.endDate.toString()),
                IssueDate: DateFormatter(item.issueDate.toString()),
                ExpiryDate: item.endDate ? DateFormatter(item.endDate.toString()) : "",
                ComplianceLevel: item.complianceLevel,
                Actions: [
                    {
                        key: index.toString(),
                        label: 'View Certificate',
                        action: () => {
                            onViewCertificate(item.id);
                        },
                        icon: {
                            color: 'info',
                            name: 'download'
                        }
                    },
                ]
            }));

        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}